import { extractData } from '@/models';
import type { Currency, PayMethod } from '@/types';
import { UserType } from '@/types';

import client from '../../assets/js/services/api';

const apiUrl = PROCESSING_API_URL;

export default {
    paymentMethods(from: Currency, to: Currency, userType?: UserType) {
        return client
            .get<{ data: PayMethod[] }>(`${ apiUrl }/public/processing/v1/payment-methods/${ from }/${ to }`, { params: { userType } })
            .then(extractData)
            .catch(e => {
                if (e.status === 404) {
                    return { data: [] };
                }

                throw e;
            });
    },

    payoutMethods(from: Currency, to: Currency, userType?: UserType) {
        return client
            .get<{ data: PayMethod[] }>(`${ apiUrl }/public/processing/v1/payout-methods/${ from }/${ to }`,{ params: { userType } })
            .then(extractData)
            .catch(e => {
                if (e.status === 404) {
                    return { data: [] };
                }

                throw e;
            });
    },
};
